// @flow
import PrivateRoute from 'components/PrivateRoute'
import FormBuilderSettingsCustomInvite from 'pages/FormBuilderSettingsCustomInvite'
import FormBuilderSettingsGeneral from 'pages/FormBuilderSettingsGeneral'
import FormBuilderSettingsNotifications from 'pages/FormBuilderSettingsNotifications'
import * as React from 'react'
import { Route, Switch } from 'react-router-dom'

import { FormAppearance } from '@/pages/FormAppearance'
import { CustomCompletePage } from '@/pages/FormBuilderSettingsCompletePage/CustomCompletePage'

import DocumentContainer from './DocumentContainer'

type Props = any

const DocumentSettingsGeneral = (props: Props) => (
  <FormBuilderSettingsGeneral {...props} resourceType="document" />
)

const DocumentSettingsNotifications = (props: Props) => (
  <FormBuilderSettingsNotifications {...props} resourceType="document" />
)

const DocumentSettingsCustomInvite = (props: Props) => (
  <FormBuilderSettingsCustomInvite {...props} resourceType="document" />
)

const DocumentFormAppearance = () => <FormAppearance />

function PDFFillerRouter(): React.Node {
  return (
    <Switch>
      <PrivateRoute
        exact
        component={DocumentSettingsGeneral}
        path={'/pdf/:resourceId/:viewMode/settings/general'}
      />
      <PrivateRoute
        exact
        component={DocumentFormAppearance}
        path={'/pdf/:resourceId/:viewMode/design'}
      />
      <PrivateRoute
        exact
        component={DocumentSettingsNotifications}
        path={'/pdf/:resourceId/:viewMode/settings/notifications'}
      />
      <PrivateRoute
        exact
        component={DocumentSettingsCustomInvite}
        path={
          '/pdf/:resourceId/:viewMode/settings/custom-email-and-sms-invitation'
        }
      />
      <PrivateRoute
        exact
        component={CustomCompletePage}
        path={'/pdf/:resourceId/:viewMode/settings/complete-page'}
      />
      <Route component={DocumentContainer} />
    </Switch>
  )
}

export default PDFFillerRouter
